export default __webpack_public_path__ + "static/media/sideMenuWhiteCheck.a46a970e.svg";